import { useEffect, useMemo, useState } from 'react';
import { AngularServices, getAngularService } from '../../../core';
import { RootScopeEvents } from '../../../../common/services/root-scope-types';
export const useChatButton = () => {
    const [isShowButton, setIsShowButton] = useState(false);
    const activeComponents = useMemo(() => getAngularService(AngularServices.ActiveComponents), []);
    useEffect(() => {
        const $rootScope = getAngularService(AngularServices.RootScope);
        const refreshButton = () => {
            setIsShowButton(activeComponents.chat.canChat());
        };
        const unsubscribes = [
            $rootScope.$on(RootScopeEvents.CHAT.ON_MESSAGE, refreshButton),
            $rootScope.$on(RootScopeEvents.CHAT.ON_UPDATE_PERSON, refreshButton),
            $rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.SESSION_DISCONNECTED, refreshButton),
        ];
        return () => {
            for (const unsubscribe of unsubscribes) {
                unsubscribe();
            }
        };
    }, [activeComponents.chat]);
    return {
        isShowButton,
    };
};
